"use client";

import {
  createPhoenixClient,
  LocalStorageAuthSessionStorage,
  MemoryAuthSessionStorage,
  type PhoenixClient,
} from "@ellipsis-labs/rise";
import { getApiUrl, getWsUrl } from "@/lib/config";

let client: PhoenixClient | null = null;

/**
 * Browser-side singleton rise client. Uses LocalStorage for session persistence
 * so auth survives page reloads. On the server we fall back to in-memory
 * storage to avoid touching localStorage during SSR or route handlers.
 */
export const getRiseClient = (): PhoenixClient => {
  if (client !== null) return client;

  const baseUrl = getApiUrl();
  if (!baseUrl) {
    throw new Error(
      "NEXT_PUBLIC_API_URL is not set — cannot initialize rise client"
    );
  }

  const storage =
    typeof window === "undefined"
      ? new MemoryAuthSessionStorage()
      : new LocalStorageAuthSessionStorage();

  const wsUrl = getWsUrl();

  client = createPhoenixClient({
    baseUrl,
    auth: true,
    authConfig: { storage },
    ws: wsUrl ? { url: wsUrl } : {},
  });

  return client;
};

export const disposeRiseClient = () => {
  client?.dispose();
  client = null;
};
